import { io } from "socket.io-client";

const BASE_URL = "https://evamobileservices.azurewebsites.net:4000"
// const BASE_URL = "http://192.168.100.60:4000"
const BASE_URL_DEV = "http://192.168.0.160:4000"
// const socket = io.connect(BASE_URL);
// const socket = io("https://evamobileservices.azurewebsites.net", {
const socket = io("https://evamobileservices.azurewebsites.net", {
  withCredentials: true,
  transports: ["websocket"], // avoid polling
  autoConnect: false         // this must match usage below
});
export default socket;
